import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY } from '../types';
import {
  createNegativeMediaIgnoringPropertyPending,
  createNegativeMediaIgnoringPropertyFulfilled,
  createNegativeMediaIgnoringPropertyRejected,
} from '../actions';
import {
  sendApiRequest,
  notifyError,
} from '../../../actions';

import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'post',
  url: 'NegativeMedia/CreateIgnoringProperty',
  onSuccess: [
    createNegativeMediaIgnoringPropertyFulfilled,
  ],
  onError: [
    createNegativeMediaIgnoringPropertyRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const createNegativeMediaIgnoringPropertyEpic$ = action$ => action$.pipe(
  ofType(CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(createNegativeMediaIgnoringPropertyPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default createNegativeMediaIgnoringPropertyEpic$;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/createNegativeMediaIgnoringPropertyEpic.js